import { Typography, useTheme } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";

type Props = {
	reminder: Reminder;
	withDate?: boolean;
};

export const ReminderRowMeta = ({ reminder, withDate = false }: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	const recurrence = t(Resources.Reminders.Recurrence[reminder.recurrence]);

	return (
		<>
			<Typography variant="hint" color={theme.palette.grey[500]}>
				{withDate
					? t(Resources.Reminders.Row.subtitle, {
							date: dateFormatter(reminder.date),
							recurrence,
						})
					: recurrence}
			</Typography>
			{reminder.snoozedUntil && (
				<Typography variant="hint" color={theme.palette.grey[500]}>
					{t(Resources.Reminders.Badge.snoozedUntil, {
						date: dateFormatter(reminder.snoozedUntil),
					})}
				</Typography>
			)}
		</>
	);
};
